import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'mon-flag-icon',
    standalone: false,
    template: '<span class="flag-icon" [ngClass]="flagClass()"></span>',
})
export class MonFlagIconComponent implements OnInit {
    @Input() flag: any;
    @Input() type?: any;

    ngOnInit (): void {
        this.type = this.type || '';
    }

    flagClass (): string {
        let flagClassType = '';
        if (this.type) {
            flagClassType += 'flag-icon-' + this.type + ' ';
        }
        return flagClassType + 'flag-icon-' + this.flag;
    }
}
